var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 14 16",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    transform: "translate(2.984938 2.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 3,
    rx: 0.75,
    width: 6,
    x: 3.015062
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0150619 1.5h1.5-.0075c.825-.0075 1.5.6675 1.5 1.4925v9c0 .825-.675 1.5-1.5 1.5h-9l-.0075-.00075c-.8325-.0075-1.5000619-.675-1.5000619-1.5075v-9c-.0074381-.8325.6675619-1.5075 1.4925619-1.5075h1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6875619 7.3875-2.0925 2.0925-1.26-1.26"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestThird);
export default __webpack_public_path__ + "static/media/request-third.aaf3b8580a8cb243c8490082956c919c.svg";
export { ForwardRef as ReactComponent };